export default __webpack_public_path__ + "static/media/user-blue.0bd8191e.svg";